import { Box } from '@global-engineering-shared/gweb-material-ui';
import { ReactNode } from 'react';

import DeviceCard from 'features/EntityDetails/components/EntityDetails/DeviceCard';
import useStyles from 'features/EntityDetails/components/EntityDetails/EntityDetailsBody/EntityDetailsBody.styles';
import EntityDetailsCard from 'features/EntityDetails/components/EntityDetails/EntityDetailsCard';
import LocationCard from 'features/EntityDetails/components/EntityDetails/LocationCard';
import TagsCard from 'features/EntityDetails/components/EntityDetails/TagsCard';
import { TDraftFrameOrLinkedAsset, TLiveFrameOrLinkedAsset } from 'types/detailsEntityType';

type EntityDetailsBodyProps<T extends TDraftFrameOrLinkedAsset | TLiveFrameOrLinkedAsset> = {
  entity: T;
  previousEntity?: TLiveFrameOrLinkedAsset;
  otherComponents?: ReactNode;
};

const EntityDetailsBody = <T extends TDraftFrameOrLinkedAsset | TLiveFrameOrLinkedAsset>({
  entity,
  previousEntity,
  otherComponents,
}: EntityDetailsBodyProps<T>) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <EntityDetailsCard entity={entity} previousEntity={previousEntity} />
      <TagsCard tags={entity.tags} previousTags={previousEntity?.tags} />
      <LocationCard entity={entity} previousEntity={previousEntity} />
      <DeviceCard entity={entity} previousEntity={previousEntity} />
      {otherComponents}
    </Box>
  );
};

export default EntityDetailsBody;
